import React from 'react';
import { Box, TextV2, TextArea } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import type { FormikProps } from 'formik';
import { AnyAmountInput } from './AnyAmountInput';

type FormValues = Readonly<{
  amount: string;
  note: string;
}>;

type ContributionFormFieldsProps = Readonly<{
  isAnyAmount: boolean;
  formik: FormikProps<FormValues>;
  currencySymbol: string;
  currencyCode: string;
  fundId: string;
  onCustomAmountChange: (value: string) => void;
  labelColor?: 'mono14' | 'mono11';
}>;

export const ContributionFormFields: React.FC<ContributionFormFieldsProps> = ({
  isAnyAmount,
  formik,
  currencySymbol,
  currencyCode,
  fundId,
  onCustomAmountChange,
  labelColor = 'mono14',
}) => {
  const { tq } = useTranslation('cashFundsGuest');

  return (
    <>
      {isAnyAmount && (
        <AnyAmountInput
          amount={formik.values.amount}
          onAmountChange={value => {
            formik.setFieldValue('amount', value);
            formik.setFieldTouched('amount', true);
            onCustomAmountChange(value);
          }}
          currencySymbol={currencySymbol}
          currencyCode={currencyCode}
          fundId={fundId}
          fieldAmountLabel={tq`Amount`}
          shouldShowAmountButtons={false}
          error={formik.errors.amount}
          touched={formik.touched.amount}
        />
      )}

      <Box marginBottom={4}>
        <TextV2
          typographyVariant="label3"
          color={labelColor}
          marginBottom={2}
        >
          {tq`Add a note (optional)`}
        </TextV2>
        <TextArea
          {...formik.getFieldProps('note')}
          placeholder={tq`Add a personal message...`}
          aria-label={tq`Add a note (optional)`}
          minRows={2}
          maxRows={4}
          maxLength={280}
        />
      </Box>
    </>
  );
};
